import { SeriesFilterState } from './series.types';

export const SERIES_ALL_OPTION = '0';
export const getDefaultSeriesFilter = (): SeriesFilterState => ({
  series: { [SERIES_ALL_OPTION]: true },
});
export const defaultSeriesFilter = getDefaultSeriesFilter();
